import {
  UPDATE_WISHLIST_CART_COUNT,
  UPDATE_DESKTOP_MODE,
  UPDATE_RESTAURANT_REVIEWS,
  SOCKET_DATA,
} from "../actionTypes/generalTypes";

export function updateDesktopMode(payload) {
  return { type: UPDATE_DESKTOP_MODE, payload };
}
export function updateWishistCartCount(payload) {
  return { type: UPDATE_WISHLIST_CART_COUNT, payload };
}
export function updateRestaurantReviews(payload) {
  return { type: UPDATE_RESTAURANT_REVIEWS, payload };
}
export function socketData(payload) {
  return { type: SOCKET_DATA, payload }
}
